var exports = {
  "kL": "x804f0401--e309bc--container",
  "HU": "x804f0401--e309bc--aside",
  "iW": "x804f0401--e309bc--main",
  "n2": "x804f0401--e309bc--main-heading",
  "Pf": "x804f0401--e309bc--label",
};

module.exports = exports;
